module.exports = __webpack_public_path__ + "img/ito-sensei-03.314a173d.jpg";